// Roles
export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  OWNER: 'owner',
  PROJECT_MANAGER: 'project_manager',
  SUPERVISOR: 'supervisor',
  CLIENT: 'client',
};

export const ROLE_LABELS = {
  [ROLES.SUPER_ADMIN]: 'Super Admin',
  [ROLES.OWNER]: 'Owner',
  [ROLES.PROJECT_MANAGER]: 'Project Manager',
  [ROLES.SUPERVISOR]: 'Supervisor',
  [ROLES.CLIENT]: 'Client',
};

export const ADMIN_ROLES = [ROLES.SUPER_ADMIN, ROLES.OWNER, ROLES.PROJECT_MANAGER];

// Project Status
export const PROJECT_STATUS = {
  ACTIVE: 'active',
  ON_HOLD: 'on_hold',
  COMPLETED: 'completed',
  ARCHIVED: 'archived',
};

export const PROJECT_STATUS_LABELS = {
  [PROJECT_STATUS.ACTIVE]: 'Active',
  [PROJECT_STATUS.ON_HOLD]: 'On Hold',
  [PROJECT_STATUS.COMPLETED]: 'Completed',
  [PROJECT_STATUS.ARCHIVED]: 'Archived',
};

// Work Categories
export const WORK_CATEGORIES = [
  { value: 'foundation', label: 'Foundation' },
  { value: 'structural', label: 'Structural' },
  { value: 'plumbing', label: 'Plumbing' },
  { value: 'electrical', label: 'Electrical' },
  { value: 'finishing', label: 'Finishing' },
  { value: 'roofing', label: 'Roofing' },
  { value: 'flooring', label: 'Flooring' },
  { value: 'painting', label: 'Painting' },
  { value: 'landscaping', label: 'Landscaping' },
  { value: 'demolition', label: 'Demolition' },
  { value: 'earthwork', label: 'Earthwork' },
  { value: 'masonry', label: 'Masonry' },
  { value: 'carpentry', label: 'Carpentry' },
  { value: 'waterproofing', label: 'Waterproofing' },
  { value: 'other', label: 'Other' },
];

// Material Units
export const MATERIAL_UNITS = [
  { value: 'kg', label: 'Kilogram (kg)' },
  { value: 'ton', label: 'Ton' },
  { value: 'bag', label: 'Bag' },
  { value: 'piece', label: 'Piece' },
  { value: 'meter', label: 'Meter' },
  { value: 'sq_meter', label: 'Sq. Meter' },
  { value: 'cu_meter', label: 'Cu. Meter' },
  { value: 'liter', label: 'Liter' },
  { value: 'bundle', label: 'Bundle' },
  { value: 'load', label: 'Load' },
  { value: 'trip', label: 'Trip' },
  { value: 'box', label: 'Box' },
  { value: 'roll', label: 'Roll' },
  { value: 'set', label: 'Set' },
  { value: 'other', label: 'Other' },
];

// Pagination
export const PAGINATION = {
  DEFAULT_LIMIT: 20,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
};

// Task / Punch List
export const TASK_STATUSES = [
  { value: 'todo', label: 'To Do', color: '#718096', bg: '#EDF2F7' },
  { value: 'in_progress', label: 'In Progress', color: '#3182CE', bg: '#EBF8FF' },
  { value: 'blocked', label: 'Blocked', color: '#E53E3E', bg: '#FFF5F5' },
  { value: 'done', label: 'Done', color: '#38A169', bg: '#F0FFF4' },
  { value: 'verified', label: 'Verified', color: '#805AD5', bg: '#FAF5FF' },
];

export const TASK_PRIORITIES = [
  { value: 'low', label: 'Low', color: '#A0AEC0', icon: 'bi-arrow-down' },
  { value: 'medium', label: 'Medium', color: '#3182CE', icon: 'bi-dash' },
  { value: 'high', label: 'High', color: '#DD6B20', icon: 'bi-arrow-up' },
  { value: 'urgent', label: 'Urgent', color: '#E53E3E', icon: 'bi-exclamation-triangle-fill' },
];

// Safety
export const SEVERITY_LEVELS = [
  { value: 'near_miss', label: 'Near Miss', color: '#A0AEC0', bg: '#EDF2F7' },
  { value: 'minor', label: 'Minor', color: '#38A169', bg: '#F0FFF4' },
  { value: 'moderate', label: 'Moderate', color: '#DD6B20', bg: '#FFFAF0' },
  { value: 'serious', label: 'Serious', color: '#E53E3E', bg: '#FFF5F5' },
  { value: 'critical', label: 'Critical', color: '#9B2C2C', bg: '#FFF5F5' },
];

export const INCIDENT_TYPES = [
  { value: 'fall', label: 'Fall' },
  { value: 'electrical', label: 'Electrical' },
  { value: 'struck_by', label: 'Struck By Object' },
  { value: 'caught_in', label: 'Caught In/Between' },
  { value: 'overexertion', label: 'Overexertion' },
  { value: 'slip_trip', label: 'Slip / Trip' },
  { value: 'fire', label: 'Fire' },
  { value: 'chemical', label: 'Chemical Exposure' },
  { value: 'equipment_failure', label: 'Equipment Failure' },
  { value: 'structural', label: 'Structural Failure' },
  { value: 'other', label: 'Other' },
];

export const INCIDENT_STATUSES = [
  { value: 'reported', label: 'Reported', color: '#E53E3E', bg: '#FFF5F5' },
  { value: 'investigating', label: 'Investigating', color: '#DD6B20', bg: '#FFFAF0' },
  { value: 'corrective_action', label: 'Corrective Action', color: '#3182CE', bg: '#EBF8FF' },
  { value: 'resolved', label: 'Resolved', color: '#38A169', bg: '#F0FFF4' },
  { value: 'closed', label: 'Closed', color: '#718096', bg: '#EDF2F7' },
];

export const CHECKLIST_CATEGORIES = [
  { value: 'ppe', label: 'PPE', icon: 'bi-shield-check' },
  { value: 'scaffolding', label: 'Scaffolding', icon: 'bi-ladder' },
  { value: 'electrical', label: 'Electrical', icon: 'bi-lightning' },
  { value: 'fire', label: 'Fire Safety', icon: 'bi-fire' },
  { value: 'excavation', label: 'Excavation', icon: 'bi-cone-striped' },
  { value: 'housekeeping', label: 'Housekeeping', icon: 'bi-house-check' },
  { value: 'equipment', label: 'Equipment', icon: 'bi-gear' },
  { value: 'signage', label: 'Signage', icon: 'bi-sign-stop' },
  { value: 'first_aid', label: 'First Aid', icon: 'bi-bandaid' },
  { value: 'general', label: 'General', icon: 'bi-clipboard-check' },
];

// Milestones / Timeline
export const MILESTONE_STATUSES = [
  { value: 'planned', label: 'Planned', color: '#A0AEC0', bg: '#EDF2F7' },
  { value: 'in_progress', label: 'In Progress', color: '#3182CE', bg: '#EBF8FF' },
  { value: 'completed', label: 'Completed', color: '#38A169', bg: '#F0FFF4' },
  { value: 'delayed', label: 'Delayed', color: '#E53E3E', bg: '#FFF5F5' },
  { value: 'cancelled', label: 'Cancelled', color: '#718096', bg: '#EDF2F7' },
];

// Change Orders / Variations
export const CO_STATUSES = [
  { value: 'draft', label: 'Draft', color: '#A0AEC0', bg: '#EDF2F7', icon: 'bi-pencil' },
  { value: 'submitted', label: 'Submitted', color: '#D69E2E', bg: '#FFFFF0', icon: 'bi-send' },
  { value: 'approved', label: 'Approved', color: '#38A169', bg: '#F0FFF4', icon: 'bi-check-circle' },
  { value: 'rejected', label: 'Rejected', color: '#E53E3E', bg: '#FFF5F5', icon: 'bi-x-circle' },
  { value: 'implemented', label: 'Implemented', color: '#3182CE', bg: '#EBF8FF', icon: 'bi-check2-all' },
];

export const CO_TYPES = [
  { value: 'addition', label: 'Addition (+)', color: '#38A169' },
  { value: 'deduction', label: 'Deduction (−)', color: '#E53E3E' },
  { value: 'modification', label: 'Modification (±)', color: '#D69E2E' },
];

export const CO_REASONS = [
  { value: 'client_request', label: 'Client Request' },
  { value: 'design_change', label: 'Design Change' },
  { value: 'site_condition', label: 'Site Condition' },
  { value: 'regulatory', label: 'Regulatory' },
  { value: 'material_substitution', label: 'Material Substitution' },
  { value: 'error_correction', label: 'Error Correction' },
  { value: 'scope_expansion', label: 'Scope Expansion' },
  { value: 'scope_reduction', label: 'Scope Reduction' },
  { value: 'other', label: 'Other' },
];

// ─── GST Invoicing ──────────────────────────────────────────────────

export const INVOICE_TYPES = [
  { value: 'sales_invoice', label: 'Sales Invoice', icon: 'bi-receipt', color: '#38A169' },
  { value: 'purchase_invoice', label: 'Purchase Invoice', icon: 'bi-cart', color: '#3182CE' },
  { value: 'credit_note', label: 'Credit Note', icon: 'bi-dash-circle', color: '#E53E3E' },
  { value: 'debit_note', label: 'Debit Note', icon: 'bi-plus-circle', color: '#DD6B20' },
  { value: 'proforma', label: 'Proforma Invoice', icon: 'bi-file-earmark', color: '#718096' },
];

export const INVOICE_STATUSES = [
  { value: 'draft', label: 'Draft', color: '#A0AEC0', bg: '#EDF2F7' },
  { value: 'issued', label: 'Issued', color: '#3182CE', bg: '#EBF8FF' },
  { value: 'sent', label: 'Sent', color: '#2BA5A0', bg: '#E6FFFA' },
  { value: 'partially_paid', label: 'Partially Paid', color: '#DD6B20', bg: '#FFFAF0' },
  { value: 'paid', label: 'Paid', color: '#38A169', bg: '#F0FFF4' },
  { value: 'cancelled', label: 'Cancelled', color: '#E53E3E', bg: '#FFF5F5' },
  { value: 'void', label: 'Void', color: '#718096', bg: '#EDF2F7' },
];

export const GST_RATES = [
  { value: 0, label: '0% (Exempt)' },
  { value: 5, label: '5%' },
  { value: 12, label: '12%' },
  { value: 18, label: '18%' },
  { value: 28, label: '28%' },
];

export const PAYMENT_METHODS = [
  { value: 'cash', label: 'Cash' },
  { value: 'bank_transfer', label: 'Bank Transfer / NEFT / RTGS' },
  { value: 'upi', label: 'UPI' },
  { value: 'cheque', label: 'Cheque' },
  { value: 'demand_draft', label: 'Demand Draft' },
  { value: 'credit_card', label: 'Credit Card' },
  { value: 'other', label: 'Other' },
];

export const INDIAN_STATES = [
  { code: '01', name: 'Jammu & Kashmir' },
  { code: '02', name: 'Himachal Pradesh' },
  { code: '03', name: 'Punjab' },
  { code: '04', name: 'Chandigarh' },
  { code: '05', name: 'Uttarakhand' },
  { code: '06', name: 'Haryana' },
  { code: '07', name: 'Delhi' },
  { code: '08', name: 'Rajasthan' },
  { code: '09', name: 'Uttar Pradesh' },
  { code: '10', name: 'Bihar' },
  { code: '11', name: 'Sikkim' },
  { code: '12', name: 'Arunachal Pradesh' },
  { code: '13', name: 'Nagaland' },
  { code: '14', name: 'Manipur' },
  { code: '15', name: 'Mizoram' },
  { code: '16', name: 'Tripura' },
  { code: '17', name: 'Meghalaya' },
  { code: '18', name: 'Assam' },
  { code: '19', name: 'West Bengal' },
  { code: '20', name: 'Jharkhand' },
  { code: '21', name: 'Odisha' },
  { code: '22', name: 'Chhattisgarh' },
  { code: '23', name: 'Madhya Pradesh' },
  { code: '24', name: 'Gujarat' },
  { code: '26', name: 'Dadra & Nagar Haveli and Daman & Diu' },
  { code: '27', name: 'Maharashtra' },
  { code: '29', name: 'Karnataka' },
  { code: '30', name: 'Goa' },
  { code: '32', name: 'Kerala' },
  { code: '33', name: 'Tamil Nadu' },
  { code: '34', name: 'Puducherry' },
  { code: '36', name: 'Telangana' },
  { code: '37', name: 'Andhra Pradesh' },
  { code: '38', name: 'Ladakh' },
];
